import React, { createContext, useContext, useState, useEffect, useCallback, useMemo } from 'react';

const DICT = {
  fr: {
    'app.name': 'SoumissionPro',
    'app.tagline': 'Soumissions pro en moins de 10 minutes',
    'nav.dashboard': 'Accueil',
    'nav.submissions': 'Soumissions',
    'nav.clients': 'Clients',
    'nav.invoices': 'Factures',
    'nav.profile': 'Profil',
    'invoice.convert': 'Convertir en facture',
    'invoice.view': 'Voir la facture',
    'invoice.preview': 'Voir ma facture',
    'invoice.send': 'Envoyer la facture',
    'invoice.converted': 'Facture créée',
    'invoice.convert_failed': 'Impossible de créer la facture',
    'invoice.not_accepted': 'Seules les soumissions acceptées peuvent être converties.',
    'invoice.already_exists': 'Une facture existe déjà pour cette soumission.',
    'invoice.list_title': 'Factures',
    'invoice.empty': 'Aucune facture. Convertis une soumission acceptée pour en créer une.',
    'invoice.detail_title': 'Facture',
    'invoice.number': 'N° de facture',
    'invoice.date': 'Date de facture',
    'invoice.due_date': "Date d'échéance",
    'invoice.status.draft': 'À envoyer',
    'invoice.status.sent': 'Envoyée',
    'invoice.status.paid': 'Payée',
    'invoice.from_submission': 'Générée à partir de la soumission {num}',
    'invoice.edit': 'Modifier',
    'invoice.save': 'Enregistrer',
    'invoice.notes': 'Notes',
    'invoice.conditions': 'Conditions',
    'invoice.site_address': 'Adresse du chantier',
    'pdf.invoice': 'FACTURE',
    'pdf.invoice_date': 'Date',
    'pdf.due_date': 'Échéance',
    'pdf.invoice_ref_submission': 'Facture générée à partir de la soumission {num}',
    'pdf.business_number': "N° d'entreprise (BN)",
    'pdf.gst_hst_number': 'N° TPS / TVH',
    'pdf.qst_number': 'N° TVQ',
    'auth.login': 'Connexion',
    'auth.signup': 'Créer un compte',
    'auth.forgot': 'Mot de passe oublié ?',
    'auth.email': 'Courriel',
    'auth.password': 'Mot de passe',
    'auth.signin_btn': 'Se connecter',
    'auth.signup_btn': 'Créer mon compte',
    'auth.google': 'Continuer avec Google',
    'auth.apple': 'Continuer avec Apple',
    'auth.no_account': "Pas encore de compte ?",
    'auth.have_account': 'Déjà un compte ?',
    'auth.reset_sent': 'Courriel de réinitialisation envoyé.',
    'auth.reset_btn': 'Envoyer le lien',
    'auth.back': 'Retour',
    'auth.logout': 'Se déconnecter',
    'auth.or': 'OU',
    'auth.email_already_used': 'Cette adresse courriel est déjà inscrite. Connectez-vous ou utilisez « Mot de passe oublié ».',
    'dash.hello': 'Bonjour',
    'dash.new_submission': 'Nouvelle soumission',
    'dash.stats.total': 'Soumissions',
    'dash.stats.accepted': 'Acceptées',
    'dash.stats.pending': 'En attente',
    'dash.stats.revenue': 'Chiffre accepté',
    'dash.recent': 'Dernières soumissions',
    'dash.empty': 'Aucune soumission. Créez-en une pour démarrer.',
    'dash.expiring': 'expire(nt) bientôt',
    'dash.tile.clients': 'Mes clients',
    'dash.tile.clients_sub': 'Carnet d\'adresses',
    'dash.tile.suppliers': 'Mes fournisseurs',
    'dash.tile.suppliers_sub': 'Import des prix négociés',
    'dash.tile.templates': 'Mes modèles de soumissions',
    'dash.tile.templates_sub': 'Soumissions réutilisables · gagne du temps',
    'dash.tile.team': 'Mon équipe',
    'dash.tile.team_sub': 'Invite tes employés · Partage soumissions, clients et fournisseurs',
    'dash.tile.invoices': 'Mes factures',
    'dash.tile.invoices_sub': 'Converties depuis les soumissions acceptées',
    'dash.tile.new_badge': 'NOUVEAU',
    'dash.sub.subscription': 'Abonnement',
    'dash.sub.trial': 'Essai gratuit',
    'dash.sub.trial_auto': 'Essai gratuit automatique – aucune carte de crédit requise.',
    'dash.sub.trial_end': 'Fin de l\'essai gratuit :',
    'dash.sub.choose_plan': 'Choisir mon plan pour continuer après l\'essai',
    'pdf.taxes_included': 'TOUTES TAXES INCLUSES',
    'work.toiture': 'Toiture',
    'work.peinture': 'Peinture',
    'work.salle_bain': 'Rénovation salle de bain',
    'work.cuisine': 'Rénovation cuisine',
    'work.sous_sol': 'Sous-sol',
    'work.plomberie': 'Plomberie',
    'work.electricite': 'Électricité',
    'work.menuiserie': 'Menuiserie',
    'work.revetement': 'Revêtement extérieur',
    'work.fenetres': 'Fenêtres et portes',
    'work.autre': 'Autre',
    'wizard.step': 'Étape',
    'wizard.of': 'sur',
    'wizard.client': 'Client',
    'wizard.work': 'Travaux',
    'wizard.materials': 'Matériaux',
    'wizard.labour': 'Main-d\'œuvre',
    'wizard.summary': 'Résumé',
    'wizard.next': 'Suivant',
    'wizard.back': 'Retour',
    'wizard.save': 'Enregistrer',
    'wizard.save_pdf': 'Enregistrer et PDF',
    'client.name': 'Nom du client',
    'client.address': 'Adresse',
    'client.phone': 'Téléphone',
    'client.email': 'Courriel',
    'work.type': 'Type de travaux',
    'work.province': 'Province',
    'work.notes': 'Notes',
    'mat.description': 'Description',
    'mat.qty': 'Qté',
    'mat.unit': 'Unité',
    'mat.price': 'Prix',
    'mat.total': 'Total',
    'mat.add': 'Ajouter un matériau',
    'mat.empty': 'Aucun matériau ajouté',
    'lab.rate': 'Taux horaire ($)',
    'lab.workers': 'Ouvriers',
    'lab.hours': 'Heures',
    'lab.total': 'Total main-d\'œuvre',
    'lab.uniform': 'Même taux pour tous',
    'lab.individual': 'Taux par ouvrier',
    'lab.add_worker': 'Ajouter un ouvrier',
    'lab.worker_name': 'Nom (optionnel)',
    'lab.worker_n': 'Ouvrier',
    'sum.materials': 'Matériaux',
    'sum.labour': 'Main-d\'œuvre',
    'sum.base': 'Sous-total',
    'sum.margin': 'Marge',
    'sum.misc': 'Frais divers',
    'sum.subtotal': 'Sous-total avant taxes',
    'sum.taxes': 'Taxes',
    'sum.grand': 'TOTAL',
    'sum.expires': 'Expire le',
    'hist.title': 'Historique',
    'hist.search': 'Rechercher…',
    'hist.all': 'Tous',
    'hist.view': 'Voir',
    'hist.duplicate': 'Dupliquer',
    'hist.edit': 'Modifier',
    'hist.delete': 'Supprimer',
    'hist.empty': 'Aucune soumission trouvée',
    'status.draft': 'Brouillon',
    'status.pending': 'En attente',
    'status.accepted': 'Acceptée',
    'status.refused': 'Refusée',
    'status.expired': 'Expirée',
    'clients.title': 'Clients',
    'clients.empty': 'Aucun client. Créez une soumission pour ajouter des clients.',
    'profile.title': 'Profil',
    'profile.company': 'Nom de l\'entreprise',
    'profile.phone': 'Téléphone',
    'profile.email': 'Courriel',
    'profile.address': 'Adresse',
    'profile.business_number': "N° d'entreprise (BN)",
    'profile.gst_hst_number': 'N° TPS / TVH',
    'profile.qst_number': 'N° TVQ',
    'profile.rate': 'Taux horaire par défaut ($)',
    'profile.margin': 'Marge par défaut (%)',
    'profile.language': 'Langue',
    'profile.province': 'Province',
    'profile.save': 'Enregistrer',
    'profile.saved': 'Profil enregistré',
    'common.save': 'Enregistrer',
    'common.cancel': 'Annuler',
    'common.confirm': 'Confirmer',
    'common.delete': 'Supprimer',
    'common.pdf': 'Générer PDF',
    'common.print': 'Imprimer',
    'common.optional': 'optionnel',
    'common.loading': 'Chargement…',
    'common.required': 'Ce champ est requis',
    'common.offline_cached': 'Hors ligne — données en cache. Les modifications nécessitent une connexion.',
    'common.number_pending': 'Numéro en attente de synchronisation',
    'common.number_pending_short': 'En attente de synchro',
    'common.number_pending_block_send': "Ce document n'a pas encore de numéro définitif — reconnectez-vous puis synchronisez avant de l'envoyer au client.",
    'supp.offline_banner': 'Hors ligne — données en cache. Les modifications nécessitent une connexion.',
    'team.offline_banner': 'Hors ligne — données en cache. Les modifications nécessitent une connexion.',
    'sync.online': 'En ligne',
    'sync.offline': 'Hors ligne',
    'sync.syncing': 'Synchronisation…',
    'sync.unsynced': 'modifications non synchronisées',
    'val.client_name_required': 'Nom du client requis',
    'val.client_address_required': 'Adresse du client requise',
    'val.work_type_missing': 'Type de travaux non sélectionné',
    'val.no_items': 'Aucun matériau ni main-d\'œuvre ajouté',
    'val.no_labour': 'Aucune main-d\'œuvre saisie',
    'val.total_invalid': 'Le total doit être supérieur à 0',
    'val.margin_low': 'Marge inférieure à 10%',
    'pdf.quote': 'SOUMISSION',
    'pdf.from': 'De',
    'pdf.to': 'Pour',
    'pdf.number': 'N°',
    'pdf.date': 'Date',
    'pdf.valid_until': 'Valide jusqu\'au',
    'pdf.description': 'Description',
    'pdf.qty': 'Qté',
    'pdf.unit': 'Unité',
    'pdf.price': 'Prix',
    'pdf.total': 'Total',
    'pdf.labour': 'Main-d\'œuvre',
    'pdf.thanks': 'Merci de votre confiance.',
    'pdf.signed_on': 'Signé le',
    'pdf.certified_verified': 'CERTIFIÉ \u00B7 VÉRIFIÉ',
    'pdf.misc_details': 'FRAIS DIVERS — DÉTAILS',
    // Team page
    'team.back': 'Retour',
    'team.title': 'MON ÉQUIPE',
    'team.member_badge': "MEMBRE D'ÉQUIPE",
    'team.member_intro': 'Tu as accès aux soumissions, clients et fournisseurs de cette compagnie.',
    'team.owner_label': "Propriétaire de l'équipe",
    'team.leave_btn': "Quitter l'équipe",
    'team.leave_confirm': "Quitter l'équipe ? Tu perdras l'accès aux données partagées.",
    'team.leave_success': "Tu as quitté l'équipe",
    'team.owner_badge': 'PROPRIÉTAIRE',
    'team.owner_title': 'Mon équipe',
    'team.owner_intro': 'Invite ton équipe à collaborer sur les soumissions, clients et fournisseurs.',
    'team.seats_used': 'Sièges utilisés',
    'team.seats_available_one': 'disponible',
    'team.seats_available_many': 'disponibles',
    'team.upgrade_title': 'Passe à un plan Équipe pour inviter ton monde',
    'team.upgrade_desc_html': 'Le plan <strong>Équipe</strong> (59,99 $/mois) inclut jusqu\'à <strong>5 utilisateurs</strong>. Le plan <strong>Pro Illimité</strong> (99,99 $/mois) en accueille <strong>10</strong>.',
    'team.upgrade_btn': 'Voir les plans',
    'team.invite_title': 'Inviter un nouveau membre',
    'team.invite_desc': "Il recevra un courriel d'invitation. Le lien est valide 14 jours.",
    'team.invite_placeholder': 'adresse@courriel.com',
    'team.invite_btn': 'Inviter',
    'team.limit_warning': 'Tu as atteint la limite de {n} utilisateurs. Retire un membre ou passe à un plan supérieur.',
    'team.members_title': 'Membres',
    'team.owner_you': 'Propriétaire (toi)',
    'team.status_pending': 'Invitation en attente',
    'team.status_active': 'Membre actif',
    'team.resend': 'Renvoyer',
    'team.empty': 'Aucun membre invité pour le moment.',
    'team.remove_confirm': "Retirer {name} de l'équipe ?",
    'team.removed': 'Membre retiré',
    'team.invite_sent': "Courriel d'invitation envoyé à {email}",
    'team.invite_no_email': "Invitation créée pour {email}, mais le courriel n'a pas pu être envoyé. Tu peux le renvoyer depuis la liste ci-dessous.",
    'team.resend_sent': 'Courriel renvoyé à {email} ✉️',
    'team.resend_failed': "Le courriel n'a pas pu être envoyé. Vérifie que la clé Resend est configurée en production.",
    'team.load_error': 'Erreur lors du chargement',
    'team.invite_error': "Erreur lors de l'invitation",
    'team.resend_error': 'Erreur lors du renvoi',
    'team.generic_error': 'Erreur',
    // Suppliers page
    'supp.title': 'Mes fournisseurs',
    'supp.subtitle': 'Importe les prix négociés avec tes fournisseurs.',
    'supp.add': 'Ajouter',
    'supp.name_label': 'Nom du fournisseur *',
    'supp.name_placeholder': 'Ex : BMR Saint-Hyacinthe',
    'supp.category_label': 'Catégorie (optionnel)',
    'supp.category_placeholder': 'Ex : Plomberie, Électricité, Bois…',
    'supp.create': 'Créer',
    'supp.cancel': 'Annuler',
    'supp.empty_title': 'Aucun fournisseur',
    'supp.empty_desc': 'Ajoute ton premier fournisseur puis importe sa liste de prix (Excel, PDF ou photo).',
    'supp.empty_btn': 'Ajouter mon premier fournisseur',
    'supp.tip_label': 'Astuce :',
    'supp.tip_text_html': 'Clique sur un fournisseur pour <strong>uploader sa liste de prix</strong> (Excel, CSV, PDF ou même une photo prise au téléphone).',
    'supp.pro_badge': 'FONCTIONNALITÉ PRO',
    'supp.paywall_title': 'Importe les prix de tes fournisseurs',
    'supp.paywall_desc_html': 'Upload tes fichiers Excel, CSV, PDF ou même une photo de la liste papier de ton fournisseur. L\'IA extrait tous tes prix négociés pour les utiliser dans tes soumissions.<br/><br/><strong>Réservé aux abonnés payants.</strong> L\'essai gratuit de 3 jours n\'inclut pas cette fonctionnalité.',
    'supp.paywall_btn': 'Voir les plans',
    'supp.name_required': 'Le nom du fournisseur est requis',
    'supp.added': 'Fournisseur ajouté ✓',
    'supp.add_failed': "Impossible d'ajouter",
    'supp.delete_confirm': 'Supprimer le fournisseur "{name}" ? Tous les prix associés seront perdus.',
    'supp.deleted': 'Supprimé',
    'supp.delete_failed': 'Suppression échouée',
    'supp.load_error': 'Erreur de chargement',
    'supp.already_active': 'Tu as déjà accès. Recharge la page.',
  },
  en: {
    'app.name': 'SoumissionPro',
    'app.tagline': 'Pro quotes in under 10 minutes',
    'nav.dashboard': 'Home',
    'nav.submissions': 'Quotes',
    'nav.clients': 'Clients',
    'nav.invoices': 'Invoices',
    'nav.profile': 'Profile',
    'invoice.convert': 'Convert to invoice',
    'invoice.view': 'View invoice',
    'invoice.preview': 'View my invoice',
    'invoice.send': 'Send invoice',
    'invoice.converted': 'Invoice created',
    'invoice.convert_failed': 'Could not create the invoice',
    'invoice.not_accepted': 'Only accepted quotes can be converted.',
    'invoice.already_exists': 'An invoice already exists for this quote.',
    'invoice.list_title': 'Invoices',
    'invoice.empty': 'No invoices yet. Convert an accepted quote to create one.',
    'invoice.detail_title': 'Invoice',
    'invoice.number': 'Invoice number',
    'invoice.date': 'Invoice date',
    'invoice.due_date': 'Due date',
    'invoice.status.draft': 'Ready to send',
    'invoice.status.sent': 'Sent',
    'invoice.status.paid': 'Paid',
    'invoice.from_submission': 'Generated from quote {num}',
    'invoice.edit': 'Edit',
    'invoice.save': 'Save',
    'invoice.notes': 'Notes',
    'invoice.conditions': 'Terms',
    'invoice.site_address': 'Job site address',
    'pdf.invoice': 'INVOICE',
    'pdf.invoice_date': 'Date',
    'pdf.due_date': 'Due date',
    'pdf.invoice_ref_submission': 'Invoice generated from quote {num}',
    'pdf.business_number': 'Business number (BN)',
    'pdf.gst_hst_number': 'GST / HST number',
    'pdf.qst_number': 'QST number',
    'auth.login': 'Sign in',
    'auth.signup': 'Create account',
    'auth.forgot': 'Forgot password?',
    'auth.email': 'Email',
    'auth.password': 'Password',
    'auth.signin_btn': 'Sign in',
    'auth.signup_btn': 'Create account',
    'auth.google': 'Continue with Google',
    'auth.apple': 'Continue with Apple',
    'auth.no_account': 'No account yet?',
    'auth.have_account': 'Already have an account?',
    'auth.reset_sent': 'Reset email sent.',
    'auth.reset_btn': 'Send link',
    'auth.back': 'Back',
    'auth.logout': 'Sign out',
    'auth.or': 'OR',
    'auth.email_already_used': 'This email is already registered. Sign in or use "Forgot password".',
    'dash.hello': 'Hello',
    'dash.new_submission': 'New quote',
    'dash.stats.total': 'Quotes',
    'dash.stats.accepted': 'Accepted',
    'dash.stats.pending': 'Pending',
    'dash.stats.revenue': 'Accepted revenue',
    'dash.recent': 'Recent quotes',
    'dash.empty': 'No quotes yet. Create one to get started.',
    'dash.expiring': 'expiring soon',
    'dash.tile.clients': 'My clients',
    'dash.tile.clients_sub': 'Address book',
    'dash.tile.suppliers': 'My suppliers',
    'dash.tile.suppliers_sub': 'Import negotiated prices',
    'dash.tile.templates': 'My quote templates',
    'dash.tile.templates_sub': 'Reusable quotes · save time',
    'dash.tile.team': 'My team',
    'dash.tile.team_sub': 'Invite your employees · Share quotes, clients and suppliers',
    'dash.tile.invoices': 'My invoices',
    'dash.tile.invoices_sub': 'Converted from accepted quotes',
    'dash.tile.new_badge': 'NEW',
    'dash.sub.subscription': 'Subscription',
    'dash.sub.trial': 'Free trial',
    'dash.sub.trial_auto': 'Automatic free trial — no credit card required.',
    'dash.sub.trial_end': 'Trial ends:',
    'dash.sub.choose_plan': 'Choose my plan to continue after trial',
    'pdf.taxes_included': 'ALL TAXES INCLUDED',
    'work.toiture': 'Roofing',
    'work.peinture': 'Painting',
    'work.salle_bain': 'Bathroom renovation',
    'work.cuisine': 'Kitchen renovation',
    'work.sous_sol': 'Basement',
    'work.plomberie': 'Plumbing',
    'work.electricite': 'Electrical',
    'work.menuiserie': 'Carpentry',
    'work.revetement': 'Exterior cladding',
    'work.fenetres': 'Windows and doors',
    'work.autre': 'Other',
    'wizard.step': 'Step',
    'wizard.of': 'of',
    'wizard.client': 'Client',
    'wizard.work': 'Work',
    'wizard.materials': 'Materials',
    'wizard.labour': 'Labour',
    'wizard.summary': 'Summary',
    'wizard.next': 'Next',
    'wizard.back': 'Back',
    'wizard.save': 'Save',
    'wizard.save_pdf': 'Save and PDF',
    'client.name': 'Client name',
    'client.address': 'Address',
    'client.phone': 'Phone',
    'client.email': 'Email',
    'work.type': 'Type of work',
    'work.province': 'Province',
    'work.notes': 'Notes',
    'mat.description': 'Description',
    'mat.qty': 'Qty',
    'mat.unit': 'Unit',
    'mat.price': 'Price',
    'mat.total': 'Total',
    'mat.add': 'Add material',
    'mat.empty': 'No materials added',
    'lab.rate': 'Hourly rate ($)',
    'lab.workers': 'Workers',
    'lab.hours': 'Hours',
    'lab.total': 'Labour total',
    'lab.uniform': 'Same rate for all',
    'lab.individual': 'Rate per worker',
    'lab.add_worker': 'Add worker',
    'lab.worker_name': 'Name (optional)',
    'lab.worker_n': 'Worker',
    'sum.materials': 'Materials',
    'sum.labour': 'Labour',
    'sum.base': 'Subtotal',
    'sum.margin': 'Margin',
    'sum.misc': 'Misc fees',
    'sum.subtotal': 'Subtotal before taxes',
    'sum.taxes': 'Taxes',
    'sum.grand': 'TOTAL',
    'sum.expires': 'Expires on',
    'hist.title': 'History',
    'hist.search': 'Search…',
    'hist.all': 'All',
    'hist.view': 'View',
    'hist.duplicate': 'Duplicate',
    'hist.edit': 'Edit',
    'hist.delete': 'Delete',
    'hist.empty': 'No quotes found',
    'status.draft': 'Draft',
    'status.pending': 'Pending',
    'status.accepted': 'Accepted',
    'status.refused': 'Refused',
    'status.expired': 'Expired',
    'clients.title': 'Clients',
    'clients.empty': 'No clients. Create a quote to add clients.',
    'profile.title': 'Profile',
    'profile.company': 'Company name',
    'profile.phone': 'Phone',
    'profile.email': 'Email',
    'profile.address': 'Address',
    'profile.business_number': 'Business number (BN)',
    'profile.gst_hst_number': 'GST / HST number',
    'profile.qst_number': 'QST number',
    'profile.rate': 'Default hourly rate ($)',
    'profile.margin': 'Default margin (%)',
    'profile.language': 'Language',
    'profile.province': 'Province',
    'profile.save': 'Save',
    'profile.saved': 'Profile saved',
    'common.save': 'Save',
    'common.cancel': 'Cancel',
    'common.confirm': 'Confirm',
    'common.delete': 'Delete',
    'common.pdf': 'Generate PDF',
    'common.print': 'Print',
    'common.optional': 'optional',
    'common.loading': 'Loading…',
    'common.required': 'This field is required',
    'common.offline_cached': 'Offline — showing cached data. Changes require a connection.',
    'common.number_pending': 'Number pending sync',
    'common.number_pending_short': 'Pending sync',
    'common.number_pending_block_send': "This document doesn't have a final number yet — reconnect and sync before sending it to the client.",
    'supp.offline_banner': 'Offline — showing cached data. Changes require a connection.',
    'team.offline_banner': 'Offline — showing cached data. Changes require a connection.',
    'sync.online': 'Online',
    'sync.offline': 'Offline',
    'sync.syncing': 'Syncing…',
    'sync.unsynced': 'unsynced changes',
    'val.client_name_required': 'Client name required',
    'val.client_address_required': 'Client address required',
    'val.work_type_missing': 'Work type not selected',
    'val.no_items': 'No materials or labour added',
    'val.no_labour': 'No labour entered',
    'val.total_invalid': 'Total must be greater than 0',
    'val.margin_low': 'Margin below 10%',
    'pdf.quote': 'QUOTE',
    'pdf.from': 'From',
    'pdf.to': 'To',
    'pdf.number': 'No.',
    'pdf.date': 'Date',
    'pdf.valid_until': 'Valid until',
    'pdf.description': 'Description',
    'pdf.qty': 'Qty',
    'pdf.unit': 'Unit',
    'pdf.price': 'Price',
    'pdf.total': 'Total',
    'pdf.labour': 'Labour',
    'pdf.thanks': 'Thank you for your trust.',
    'pdf.signed_on': 'Signed on',
    'pdf.certified_verified': 'CERTIFIED \u00B7 VERIFIED',
    'pdf.misc_details': 'MISC FEES — DETAILS',
    // Team page
    'team.back': 'Back',
    'team.title': 'MY TEAM',
    'team.member_badge': 'TEAM MEMBER',
    'team.member_intro': "You have access to this company's quotes, clients and suppliers.",
    'team.owner_label': 'Team owner',
    'team.leave_btn': 'Leave the team',
    'team.leave_confirm': "Leave the team? You'll lose access to shared data.",
    'team.leave_success': 'You left the team',
    'team.owner_badge': 'OWNER',
    'team.owner_title': 'My team',
    'team.owner_intro': 'Invite your team to collaborate on quotes, clients and suppliers.',
    'team.seats_used': 'Seats used',
    'team.seats_available_one': 'available',
    'team.seats_available_many': 'available',
    'team.upgrade_title': 'Upgrade to a Team plan to invite your people',
    'team.upgrade_desc_html': 'The <strong>Team</strong> plan ($59.99/month) includes up to <strong>5 users</strong>. The <strong>Pro Unlimited</strong> plan ($99.99/month) supports <strong>10</strong>.',
    'team.upgrade_btn': 'View plans',
    'team.invite_title': 'Invite a new member',
    'team.invite_desc': 'They will receive an invitation email. The link is valid for 14 days.',
    'team.invite_placeholder': 'email@address.com',
    'team.invite_btn': 'Invite',
    'team.limit_warning': "You've reached the limit of {n} users. Remove a member or upgrade to a higher plan.",
    'team.members_title': 'Members',
    'team.owner_you': 'Owner (you)',
    'team.status_pending': 'Invitation pending',
    'team.status_active': 'Active member',
    'team.resend': 'Resend',
    'team.empty': 'No member invited yet.',
    'team.remove_confirm': 'Remove {name} from the team?',
    'team.removed': 'Member removed',
    'team.invite_sent': 'Invitation email sent to {email}',
    'team.invite_no_email': "Invitation created for {email}, but the email couldn't be sent. You can resend it from the list below.",
    'team.resend_sent': 'Email resent to {email} ✉️',
    'team.resend_failed': "The email couldn't be sent. Check that the Resend key is configured in production.",
    'team.load_error': 'Error loading',
    'team.invite_error': 'Error during invitation',
    'team.resend_error': 'Error resending',
    'team.generic_error': 'Error',
    // Suppliers page
    'supp.title': 'My suppliers',
    'supp.subtitle': 'Import prices negotiated with your suppliers.',
    'supp.add': 'Add',
    'supp.name_label': 'Supplier name *',
    'supp.name_placeholder': 'Ex: BMR Saint-Hyacinthe',
    'supp.category_label': 'Category (optional)',
    'supp.category_placeholder': 'Ex: Plumbing, Electrical, Wood…',
    'supp.create': 'Create',
    'supp.cancel': 'Cancel',
    'supp.empty_title': 'No supplier',
    'supp.empty_desc': 'Add your first supplier then import their price list (Excel, PDF or photo).',
    'supp.empty_btn': 'Add my first supplier',
    'supp.tip_label': 'Tip:',
    'supp.tip_text_html': 'Tap on a supplier to <strong>upload their price list</strong> (Excel, CSV, PDF or even a photo taken with your phone).',
    'supp.pro_badge': 'PRO FEATURE',
    'supp.paywall_title': "Import your suppliers' prices",
    'supp.paywall_desc_html': "Upload your Excel, CSV, PDF files or even a photo of your supplier's paper price list. AI extracts all your negotiated prices to use them in your quotes.<br/><br/><strong>Paid subscribers only.</strong> The 3-day free trial doesn't include this feature.",
    'supp.paywall_btn': 'View plans',
    'supp.name_required': 'Supplier name is required',
    'supp.added': 'Supplier added ✓',
    'supp.add_failed': 'Unable to add',
    'supp.delete_confirm': 'Delete supplier "{name}"? All associated prices will be lost.',
    'supp.deleted': 'Deleted',
    'supp.delete_failed': 'Deletion failed',
    'supp.load_error': 'Loading error',
    'supp.already_active': 'You already have access. Refresh the page.',
  },
};

export const WORK_TYPES = {
  fr: [
    'Rénovation cuisine',
    'Rénovation salle de bain',
    'Toiture',
    'Revêtement extérieur',
    'Plancher',
    'Peinture',
    'Électricité',
    'Plomberie',
    'Charpenterie',
    'Béton et fondation',
    'Paysagement',
    'Démolition',
    'Agrandissement',
    'Climatisation et thermopompes',
    'Isolation',
    'Excavation et drainage',
    'Terrasse et patio',
    'Garage et atelier',
    'Autre',
  ],
  en: [
    'Kitchen renovation',
    'Bathroom renovation',
    'Roofing',
    'Exterior cladding',
    'Flooring',
    'Painting',
    'Electrical',
    'Plumbing',
    'Framing',
    'Concrete & foundation',
    'Landscaping',
    'Demolition',
    'Extension',
    'HVAC and heat pumps',
    'Insulation',
    'Excavation and drainage',
    'Deck and patio',
    'Garage and workshop',
    'Other',
  ],
};

/**
 * Translates a work type label from any language to the target language.
 * If the work type isn't in the predefined list (custom user entry),
 * returns it unchanged.
 *
 * @param {string} workType - The work type label to translate
 * @param {'fr'|'en'} targetLang - Target language
 * @returns {string} Translated label or original if not in predefined list
 */
export function translateWorkType(workType, targetLang) {
  if (!workType || !targetLang) return workType || '';
  const target = targetLang === 'en' ? WORK_TYPES.en : WORK_TYPES.fr;
  // Try to find the work type in either FR or EN list and map to target
  const idxFr = WORK_TYPES.fr.findIndex((w) => w.toLowerCase() === workType.toLowerCase());
  if (idxFr !== -1) return target[idxFr];
  const idxEn = WORK_TYPES.en.findIndex((w) => w.toLowerCase() === workType.toLowerCase());
  if (idxEn !== -1) return target[idxEn];
  return workType;
}

const I18nContext = createContext({ lang: 'fr', t: (k) => k, setLang: () => {} });

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem('lang') || 'fr');

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const setLang = useCallback((l) => {
    setLangState(l);
    localStorage.setItem('lang', l);
  }, []);

  const t = useCallback(
    (key) => (DICT[lang] && DICT[lang][key]) || DICT.fr[key] || key,
    [lang]
  );

  const value = useMemo(() => ({ lang, setLang, t }), [lang, t]);

  return (
    <I18nContext.Provider value={value}>{children}</I18nContext.Provider>
  );
}

export function useT() {
  return useContext(I18nContext);
}
